module.exports = __webpack_public_path__ + "img/geofisica_16-9_960.60ecd386.jpg";